/* ----------------------------------------------------------------------------
 * Bundle campaigns engine
 * Ported from the legacy "Base" theme (theme.js) so the bundle popup works in
 * the Horizon theme. The original relied on jQuery + lodash + a global `theme`
 * object; this is a self-contained vanilla rewrite that defines
 * `window.theme.campaigns` with the same bundle rules and the same
 * `buildCartMessage(cart, messageMethod, currentProduct)` contract the popup
 * components below expect. No external libraries required.
 * -------------------------------------------------------------------------- */
(function () {
  window.theme = window.theme || {};
  window.theme.cache = window.theme.cache || { products: [] };

  // Already defined (e.g. legacy theme.js present) — don't override it.
  if (window.theme.campaigns) return;

  function findByHandle(products, handle) {
    return (products || []).find(function (p) { return p.handle === handle; });
  }

  // Replicates the legacy priority check for cart items already in a bundle.
  function _checkCampaignIsHigherPriority(lineItem, campaignID) {
    if (lineItem.properties && lineItem.properties._discount_bundle == true && lineItem.properties._discount_id) {
      var foundCampaignID = lineItem.properties._discount_id;
      var foundCampaignIndex = window.theme.campaigns.findIndex(function (c) { return c.id === foundCampaignID; });
      if (foundCampaignIndex == -1) return true;
      return false;
    }
    return true;
  }

  // Sums line-item quantities. For a product JSON (no quantity) this yields NaN,
  // which the popup intentionally detects via isNaN() to show the "complete the
  // bundle" message — behaviour kept identical to the legacy theme.
  function QuantityCounter() {
    this.returnCount = function (lineItems) {
      var count = 0;
      (lineItems || []).forEach(function (lineItem) { count += lineItem.quantity; });
      return count;
    };
  }

  // True if the bundle discount is already applied to the cart.
  function SavingsDeal(savings) {
    this.savings = savings;
    this.checkIfDealExists = function (lineItems) {
      var dealFound = false;
      (lineItems || []).forEach(function (lineItem) {
        (lineItem.discounts || []).forEach(function (discount) {
          if (discount.amount == savings) dealFound = true;
        });
      });
      return dealFound;
    };
  }

  function MinProductsMessage(min, message, savings) {
    this.min = min;
    this._message = message;
    this.savings = savings;
    this.met = function (count) { return count >= min; };
    this.message = function (count) {
      var remaining = this.min - count;
      if (remaining == 0 || count == 0) return;
      var message2 = this._message;
      message2 = message2.replace('{count}', remaining);
      message2 = message2.replace('{savings}', this.savings);
      message2 = remaining == 1
        ? message2.replace(new RegExp('{s}', 'g'), '')
        : message2.replace(new RegExp('{s}', 'g'), 's');
      return message2;
    };
  }

  function PriceAndTagsSelector(condition, price, tags) {
    this.condition = condition;
    this.price = price;
    this.tags = tags;
    this.requestComplete = false;
    var self = this;

    // Legacy fetched /collections/all/{tag}?view=json to learn the tags of
    // products already in the cart. That alternate JSON view may not exist in
    // this theme, so we attempt it but ALWAYS invoke the callback afterwards —
    // the product-detail path (currentProduct) matches without it.
    this.getProducts = function (callback) {
      var done = function () {
        self.requestComplete = true;
        if (typeof callback === 'function') callback();
      };
      if (self.requestComplete || !self.tags.length) { done(); return; }

      var requestsComplete = 0;
      var requestsTodo = self.tags.length;
      self.tags.forEach(function (tag) {
        fetch('/collections/all/' + tag + '?view=json')
          .then(function (r) { return r.ok ? r.text() : '[]'; })
          .then(function (text) {
            try {
              window.theme.cache.products = window.theme.cache.products.concat(JSON.parse(text));
            } catch (e) { /* no JSON view available — ignore */ }
          })
          .catch(function () { /* network error — ignore */ })
          .finally(function () {
            requestsComplete += 1;
            if (requestsComplete === requestsTodo) done();
          });
      });
    };

    this.match = function (lineItem, campaignID, isCurrentProduct) {
      var product = isCurrentProduct ? lineItem : findByHandle(window.theme.cache.products, lineItem.handle);
      var match = false;
      if (!product) return match;

      var containsTag = (product.tags || []).some(function (x) {
        return self.tags.some(function (y) { return y === x; });
      });
      if (!containsTag) return false;

      var originalPrice = lineItem.original_price || lineItem.price;
      switch (self.condition) {
        case 'greater_than': if (originalPrice > self.price) match = true; break;
        case 'less_than': if (originalPrice < self.price) match = true; break;
      }
      if (lineItem.properties && lineItem.properties._discount_bundle == true) {
        match = match && _checkCampaignIsHigherPriority(lineItem, campaignID);
      }
      return match;
    };
  }

  function DiscountCampaign(deal, selector, counter, requirement, id, url) {
    this.deal = deal;
    this.selector = selector;
    this.counter = counter;
    this.requirement = requirement;
    this.id = id;
    this.url = url;
    var self = this;

    this.getApplicableProducts = function (cart, currentProduct) {
      var applicableItems = [];
      if (currentProduct) {
        var cartItemsWithProductID = (cart.items || []).filter(function (item) {
          return item.product_id == currentProduct.id;
        });
        applicableItems = cartItemsWithProductID.length
          ? cartItemsWithProductID.filter(function (item) { return self.selector.match(item, self.id); })
          : [currentProduct].filter(function (item) { return self.selector.match(item, self.id, true); });
      } else {
        applicableItems = (cart.items || []).filter(function (item) { return self.selector.match(item, self.id); });
      }
      return applicableItems;
    };

    this.buildCartMessage = function (cart, messageMethod, currentProduct) {
      function buildMessage() {
        var lineItems = self.getApplicableProducts(cart, currentProduct);
        var count = self.counter.returnCount(lineItems);
        var requirementMet = self.requirement.met(count);
        var priority = window.theme.campaigns.findIndex(function (c) { return c.id === self.id; });
        if (!requirementMet && lineItems.length > 0) {
          var countForMessage = self.requirement.message(count);
          messageMethod(countForMessage, self.id, false, priority, self.url, self.requirement.min, count);
        }
      }
      var dealExists = self.deal.checkIfDealExists(cart.items);
      if (!dealExists) self.selector.getProducts(buildMessage);
    };
  }

  // Bundle rules (mirrors the legacy theme's campaign list).
  window.theme.campaigns = [
    new DiscountCampaign(new SavingsDeal(7000),  new PriceAndTagsSelector('greater_than', 0, ['bundle:promo-one']), new QuantityCounter(), new MinProductsMessage(3, 'Buy 3 Items, Save $70', '$70'), 'buy-3-items-save-70', '/collections/buy-3-items-save-70'),
    new DiscountCampaign(new SavingsDeal(2000),  new PriceAndTagsSelector('greater_than', 0, ['bundle:sock']), new QuantityCounter(), new MinProductsMessage(3, 'Buy 3 socks, Save $20', '$20'), 'buy-3-items-save-20', '/collections/socks'),
    new DiscountCampaign(new SavingsDeal(12000), new PriceAndTagsSelector('greater_than', 0, ['bundle:blazerpack-blazer', 'bundle:blazerpack-shirt', 'bundle:blazerpack-pants']), new QuantityCounter(), new MinProductsMessage(3, 'Buy Blazer, Pants & Shirt, Save $120', '$120'), 'blazerpack', '/collections/buy-the-look'),
    new DiscountCampaign(new SavingsDeal(5000),  new PriceAndTagsSelector('greater_than', 0, ['bundle:shorts']), new QuantityCounter(), new MinProductsMessage(2, 'Buy 2, save $50', '$50'), 'buy-2-items-save-50', '/collections/buy-2-items-save-50'),
    new DiscountCampaign(new SavingsDeal(9900),  new PriceAndTagsSelector('greater_than', 0, ['bundle:polo']), new QuantityCounter(), new MinProductsMessage(2, 'Polos, $99 each when you buy 2 or more', '$99'), 'buy-2-items-save-99-next', '/collections/polos-tees')
  ];
})();

// This file is included once per bundle placement (PDP accordion, cart
// drawer, etc.), so it can execute more than once on the same page. Guard
// ALL class declarations and registrations so a repeat include doesn't throw.
if (!customElements.get('component-product-bundle-slider')) {

  class ProductBundlePopup extends HTMLElement {
    constructor() {
      super();
      this.closeBtn = this.querySelector('[data-close-btn]');
      this.querySelectorAll('[data-close-btn]').forEach(
        (button) => button.addEventListener('click', this.onButtonClick.bind(this))
      );
    }

    onButtonClick(event) {
      event.preventDefault();
      this.classList.add('hidden');
    }
  }

  class ProductBundlePopupContainer extends HTMLElement {
    constructor() {
      super();
      this.currentProduct = this.getProductJSON();
      this.wrapper = this.querySelector('[data-product-bundle-popup-container]');
      this.toggler = this.querySelector('[data-product-bundle-popup-toggler]');
      this.toggler?.addEventListener('click', this.onClickToggler.bind(this));
      this.inCart = this.hasAttribute('in-cart');
      this.init();
    }

    init() {
      this.fetchCart(this.buildMessages.bind(this));
    }

    onClickToggler() {
      this.wrapper.classList.toggle('hidden');
      this.toggler.classList.toggle('is-active');
    }

    getProductJSON() {
      var productJSON = document.querySelector('[data-product-json]');
      if (productJSON) {
        return JSON.parse(productJSON.innerHTML);
      }
      return null;
    }

    buildMessages(data) {
      this.wrapper.innerHTML = '';
      if (!this.inCart) {
        theme.campaigns.forEach(campaign => {
          campaign.buildCartMessage(data, this.buildMessagesCallback.bind(this), this.currentProduct);
        });
      } else {
        theme.campaigns.forEach(campaign => {
          campaign.buildCartMessage(data, this.buildMessagesCallback.bind(this));
        });
      }
    }

    buildMessagesCallback(body, id, persistent, priority, url, min, count) {
      this.initBundlePopup(body, url, min, count);
    }

    initBundlePopup(body, url, min, count) {
      console.log('do init bundle popup...');
      var countForMessage = isNaN(count) ? `Buy ${ min } to complete the bundle!` : `Buy ${min - count} more item(s) to complete the bundle!`;
      var popupHTML = `<product-bundle-popup class="product-bundles-popup">
        <div class="product-bundles-popup__tag">Bundle</div>
        <button class="product-bundles-popup__close-btn" data-close-btn="">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M15 5L5 15" stroke="black" stroke-linecap="round" stroke-linejoin="round"></path>
            <path d="M5 5L15 15" stroke="black" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
        </button>
        <div class="product-bundles-popup__title">${body}</div>
        <div class="product-bundles-popup__desc">${ countForMessage }</div>
        <a href="${url}" class="product-bundles-popup__link">Shop Bundle <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M3.33301 8H12.6663" stroke="#E41B24" stroke-linecap="round" stroke-linejoin="round"></path>
          <path d="M8 3.33337L12.6667 8.00004L8 12.6667" stroke="#E41B24" stroke-linecap="round" stroke-linejoin="round"></path>
        </svg></a>
      </product-bundle-popup>`;
      this.wrapper.innerHTML = this.wrapper.innerHTML + popupHTML;
    }

    async fetchCart(callback) {
      const response = await fetch(`${Theme.routes.cart_url}.js`);
      const data = await response.json();
      callback(data);
    }
  }

  class ProductBundleSlider extends ProductBundlePopupContainer {
    constructor() {
      super();
    }

    init() {
      this.ids = [];
      this.defineElements();
      this.addListeners();
      this.updateParentVisibility();
      this.updateCount();
      super.init();
    }

    update() {
      this.clearList();
      super.init();
    }

    defineElements() {
      this.list = this.querySelector('[data-product-bundles-list]');
      this.count = this.closest('accordion-custom')?.querySelector('[data-product-bundle-count]');
    }

    clearList() {
      if (this.list) {
        this.list.innerHTML = '';
      }
      this.ids = [];
      this.setAttribute('default-hidden', '');
      this.updateParentVisibility();
      this.updateCount();
    }

    addListeners() {
      document.addEventListener(
        'bundle::trigger-slider-update',
        this.update.bind(this)
      );

      // Native Horizon cart event (dispatched by product-form.js and the cart
      // drawer/items component on every add/update/remove) — refreshes the
      // bundle deals list whenever the cart changes, without any extra wiring.
      document.addEventListener(
        'cart:update',
        this.update.bind(this)
      );
    }

    updateParentVisibility() {
      const parentAccordion = this.closest('accordion-custom');
      if (parentAccordion) {
        if (this.hasAttribute('default-hidden')) {
          parentAccordion.style.display = 'none';
        } else {
          parentAccordion.style.display = '';
        }
      }
    }

    updateCount() {
      if (this.count) {
        this.count.textContent = this.ids.length ? `(${this.ids.length})` : '';
      }
    }

    buildMessages(data) {
      if (!this.inCart) {
        theme.campaigns.forEach(campaign => {
          campaign.buildCartMessage(data, this.buildMessagesCallback.bind(this), this.currentProduct);
        });
      } else {
        theme.campaigns.forEach(campaign => {
          campaign.buildCartMessage(data, this.buildMessagesCallback.bind(this));
        });
      }
    }

    buildMessagesCallback(body, id, persistent, priority, url, min, count) {
      this.buildSlider(body, url, min, count, id);
    }

    buildSlider(body, url, min, count, id) {
      if (this?.ids?.includes(id)) {
        return null;
      }

      var remaining = isNaN(count) ? min : (min - count);
      var progressMessage = remaining <= 1
        ? 'Add 1 more to complete bundle'
        : `Add ${remaining} more to complete bundle`;

      var itemHTML = this.inCart
        ? `<div class="product-bundles-item">
            <div class="product-bundles-item__content">
              <div class="product-bundles-item__title">${body}</div>
              <div class="product-bundles-item__subtitle">${progressMessage}</div>
            </div>
            <a href="${url}" class="product-bundles-item__link">Shop</a>
          </div>`
        : `<div class="product-bundles-item product-bundles-item--pdp">
            <div class="product-bundles-item__content">
              <div class="product-bundles-item__tag">Buy &amp; save</div>
              <div class="product-bundles-item__title">${body}</div>
            </div>
            <a href="${url}" class="product-bundles-item__link product-bundles-item__link--pdp">Shop now</a>
          </div>`;

      this.list?.insertAdjacentHTML('beforeend', itemHTML);

      this.removeAttribute('default-hidden');
      this?.ids?.push(id);
      this.updateParentVisibility();
      this.updateCount();
    }
  }

  customElements.define('product-bundle-popup', ProductBundlePopup);
  customElements.define('product-bundle-popup-container', ProductBundlePopupContainer);
  customElements.define('component-product-bundle-slider', ProductBundleSlider);
}
